const projectsData = [
    {
      imgPath: require("../../Assets/Projects/chatify.png"),
      title: "Assignment Solver",
      description: "Assignment Solver is made to help students to skip the boring tasks that can be done by AI React.js, Material-UI, Flask and Large Language Model. Have features which allows user for upload assigment images, get pharaphrased answers from LLM and then print a hand written solution.",
      ghLink: "https://github.com/AliHM15",
      demoLink: "",
      technologies: "React.js, Material-UI, Firebase, Flask, Python, Javascript"
    },
    {
      imgPath: require("../../Assets/Projects/RPC.jpg"),
      title: "Rock Paper Scissor Game",
      description: "I created the traditional Rock Paper Scissor game but on computer where long lost friends can play play this game remotly.",
      ghLink: "https://github.com/AliHM15",
      demoLink: "",
      technologies: "Node, Socket.io, Javascript"
    },
    {
      imgPath: require("../../Assets/Projects/leaf.png"),
      title: "Multi-Omics Data Integration",
      description: "Developed a portal for Doctors and Researchers where most effective cancer drug will be recommended based on the oncology and disease data provided by the user.",
      ghLink: "https://github.com/AliHM15",
      demoLink: "",
      technologies: "Data Engineering, React, Node, Neo4j, Javascript, Network, Genes, Bio-tech, Python"
    },
    {
      imgPath: require("../../Assets/Projects/suicide.png"),
      title: "Mental Health Chat Bot",
      description: "Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention.",
      ghLink: "https://github.com/AliHM15",
      demoLink: "",
      technologies: "Natural Language Processing, LLM, NLP, React, Node, Javascript, Python, Flask"
    },
  ];
  
  export default projectsData;
  